<div class="m-item ion-padding">
  <ion-icon class="m-item__icone" [name]="icone" color="medium"></ion-icon>
  <ion-text class="m-item__titulo" color="medium">
    {{ titulo }}
  </ion-text>
  <usucampeao-status-preenchimento *ngIf="status" [status]= status></usucampeao-status-preenchimento>
</div>
